module.exports = __webpack_public_path__ + "img/what.777869d3.svg";